export default {"src":"/_next/static/media/arg.0c8962e2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};